const classCustomSelectOpen = 'custom-select--open',
    classCustomSelectDropdownOpenTop = 'custom-select--dropdown-open-top';

// check if there is enough space below select for dropdown - if not, move to top via css class
$.fn.checkBottomSpace = function () {
    let $customSelect = $(this),
        $dropdown = $(this).find('.custom-select__dropdown'),
        offset = $customSelect.offset();

    if ($dropdown.length > 0) {
        let dropdownHeight = $dropdown.outerHeight(),
            availableBottomSpace = $('html').outerHeight() - offset.top - $customSelect.outerHeight();

        if ($customSelect.closest('.menu-overlay').length > 0) return; // skip the one in menu-overlay; always open top

        if (dropdownHeight > availableBottomSpace) {
            $customSelect.addClass(classCustomSelectDropdownOpenTop);
        } else {
            $customSelect.removeClass(classCustomSelectDropdownOpenTop);
        }
    }
}

$('.custom-select').each(function () {
   let $elem = $(this),
       $toggle = $('.custom-select__button', this);

   $(this).checkBottomSpace();

   $toggle.on('click', function () {
       if ($elem.hasClass(classCustomSelectOpen)) {
           $elem.removeClass(classCustomSelectOpen);
       } else {
           $elem.addClass(classCustomSelectOpen);
       }
   });
});

//close dropdowns when clicking outside dropdown windows
$(document).on('click', function(e) {
    if (!$(e.target).closest('.custom-select').length > 0 ) {
        $('.custom-select').each( function() {
            if ($(this).hasClass(classCustomSelectOpen)) {
                $(this).removeClass(classCustomSelectOpen);
            }
        });
    }
});

$(window).on('resize', function () {
    $('.custom-select').each(function () {
        $(this).checkBottomSpace();
    });
});
